import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('field/field/([a-zA-Z]+)', form);
Router.get('field/([a-zA-Z]+)', form);
Router.get('field', index);
